module.exports = __webpack_public_path__ + "static/img/yiqingtang.0cbc26f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/yiqingtang.jpg
// module id = FtEn
// module chunks = 0